(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["codex-account-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    var buttons = document.querySelectorAll('.codex-account-open');

    buttons.forEach(function (button) {
      var panelId = button.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);

      if (!panel || button.dataset.accountPanelReady === 'true') return;
      button.dataset.accountPanelReady = 'true';

      function closePanel() {
        panel.hidden = true;
        button.setAttribute('aria-expanded', 'false');
      }

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        button.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) {
          var email = panel.querySelector('input[type="email"]');
          if (email) email.focus();
        }
      });

      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      var loginForm = panel.querySelector('[data-customer-login-form]');
      if (loginForm) {
        loginForm.addEventListener('submit', function (event) {
          event.preventDefault();
          var email = loginForm.querySelector('input[name="login_hint"]');

          if (!email || !email.reportValidity()) return;

          var loginUrl = new URL(loginForm.dataset.loginUrl, window.location.origin);
          loginUrl.searchParams.set('login_hint', email.value.trim());
          window.top.location.href = loginUrl.toString();
        });
      }

      document.addEventListener('click', closePanel);
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !panel.hidden) {
          closePanel();
          button.focus();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
